export function easeInOutExpo(x: number): number {
    if (x === 0 || x === 1) {
        return x;
    }
    return x < 0.5 ? 2 ** (20 * x - 10) / 2 : (2 - 2 ** (-20 * x + 10)) / 2;
}
